import * as React from "react";
import { Link } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import './styles/Services.css';
import './styles/NaturalDisaster.css';
import 'slick-carousel/slick/slick.css';
import './styles/slickSlider.css';
import { naturalDisasters, manualDiasters } from "../data/disasteraData";

const DETAIL_PATH = "/knowledgeBase/risk-by-location-detail";

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const HazardCarousel = ({ id, title, description, items, imageKey }) => {
  const trackRef = React.useRef(null);
  const [edges, setEdges] = React.useState({ start: true, end: false });

  const updateEdges = React.useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    setEdges({
      start: el.scrollLeft <= 4,
      end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 4,
    });
  }, []);

  React.useEffect(() => {
    updateEdges();
    window.addEventListener("resize", updateEdges);
    return () => window.removeEventListener("resize", updateEdges);
  }, [updateEdges]);

  const scrollByPage = (direction) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * el.clientWidth * 0.9, behavior: prefersReducedMotion() ? "auto" : "smooth" });
  };

  return (
    <div className="mrf-container">
      <div className="mrf-hazards__head">
        <div>
          <h2 id={`${id}-heading`} className="mrf-heading" style={{ marginBottom: 8 }}>{title}</h2>
          <p className="mrf-lead" style={{ margin: 0 }}>{description}</p>
        </div>
        <div className="mrf-hazards__controls">
          <button
            type="button"
            className="mrf-hazards__control"
            aria-label={`Previous ${title.toLowerCase()}`}
            disabled={edges.start}
            onClick={() => scrollByPage(-1)}
          >
            <ChevronLeftIcon aria-hidden="true" />
          </button>
          <button
            type="button"
            className="mrf-hazards__control"
            aria-label={`Next ${title.toLowerCase()}`}
            disabled={edges.end}
            onClick={() => scrollByPage(1)}
          >
            <ChevronRightIcon aria-hidden="true" />
          </button>
        </div>
      </div>

      <ul
        ref={trackRef}
        className="mrf-hazards__track"
        aria-labelledby={`${id}-heading`}
        onScroll={updateEdges}
      >
        {items.map((item) => (
          <li key={item.name} className="mrf-hazard">
            <Link className="mrf-hazard__link" to={DETAIL_PATH} state={item}>
              <img className="mrf-hazard__img" src={item[imageKey]} alt="" loading="lazy" draggable="false" />
              <span className="mrf-hazard__label">
                <span className="mrf-hazard__name">{item.name}</span>
                <span className="mrf-hazard__go" aria-hidden="true">→</span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

const NaturalDisasters = () => (
  <>
    <section className="mrf-section" aria-labelledby="natural-heading">
      <HazardCarousel
        id="natural"
        title="Natural Disasters"
        description="What are the typical risks that could occur in your community?"
        items={naturalDisasters}
        imageKey="naturalimage"
      />
    </section>
    <section className="mrf-section" aria-labelledby="manmade-heading">
      <HazardCarousel
        id="manmade"
        title="Man-Made Disasters"
        description="These can be divided into different categories and they include technological hazards, sociological hazards and transportation hazards among others."
        items={manualDiasters}
        imageKey="image"
      />
    </section>
  </>
);

export default NaturalDisasters;
